import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDeactivatedLabelProps {
  title: string;
}

export const DeactivatedLabel: React.FC<IDeactivatedLabelProps> = ({ title }) => {
  return (
    <div className={styles['label']} data-testid="offers_history_deactivated_label">
      <UIText3 color="text-inverted-default">{title}</UIText3>
    </div>
  );
};
